import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import CoverSplit from '../common/CoverSplit';
import IconSave from '../svg/IconDownload'; //'../svg/IconSave';
import IMG from './media/SP3.png';
import { connect } from "react-redux";

import usePlaylistMenu from '../../../hooks/usePlaylistMenu';

function ConnectedSharedPlaylistMenu({
  playlist, track_count, isEnabled, socket, isWatcher
}) {

  const afterDrop = (playlist) => { socket.emit(`update shared playlist`, playlist.tracks) }
  const to = `/session-playlist`;
  const {
    match, setHistory, opacity, copySharedPlaylist
  } = usePlaylistMenu(playlist, to, false, { afterDrop });

  return isEnabled ? (
    <div className={`menu-left-container pm ${match && `selected`} `} >
      <Link id={`link-ref-${playlist.id}`} onClick={setHistory} style={{textDecoration: `none`}} to={to}>
        <div id={`ref-${playlist.id}`} className={`flexRow menu-shared ${match && `selected`}`} ref={null} style={{ opacity, cursor: `default`}} >
          <CoverSplit name={playlist.name} images={[IMG]} size={Config.MENU_COVER_SIZE} />
          <div className={`flexColumn playlist-menu-infos type-small`}>
            <span className={`type-medium fz13`}>{Config.limitString(playlist.name, 16)}</span>
            <span className={`playlist-menu-owner type`}>{`${playlist.tracks.length} Tracks`}</span>
          </div>
          <IconSave className={`session-icon-save`} style={{ cursor: 'pointer', position: `absolute`, right: 8, top: 16 }} onClick={copySharedPlaylist} />
        </div>
      </Link>
    </div>
  ) : null;
}

ConnectedSharedPlaylistMenu.propTypes = {
  playlist: PropTypes.object.isRequired,
  track_count: PropTypes.number.isRequired,
  isEnabled:  PropTypes.bool.isRequired,
}

const SharedPlaylistMenu = connect(
  state => ({
    socket: state.socketPM,
    isEnabled: state.enablePM,
    isWatcher: state.isWatcherPM
  })
)(ConnectedSharedPlaylistMenu);

export default SharedPlaylistMenu;
